import {
	entityFields as customEntityFields, 
	entityLayout as customEntityLayout, 
} from '../../conf/entity'

const entityFields = Object.assign({
	page: [
		{
			name: 'title',
			type: 'text',
			label: 'Titlu',
			t: true
		}
	],
	
	template: [
		{
			name: 'title',
			type: 'text',
			label: 'Titlu',
			t: true
		}
	],
	
	region: [
		{
			name: 'title',
			type: 'text',
			label: 'Nume'
		}
	],
	
	frag: [
		{
			name: 'name',
			type: 'text',
			label: 'Nume'
		},
		{
			name: 'label',
			type: 'text',
			label: 'Eticheta'
		}
	]
	
}, customEntityFields)
const entityLayout = Object.assign({
}, customEntityLayout)
export {entityFields, entityLayout}



// WEBPACK FOOTER //
// ./src/fm/conf/entity.js